import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runMutationOnce, runQueryOnce, runTableQuery } from '@/pages/shared/rtk-query-helpers';

export const accountApi = createApi({
    reducerPath: 'accountApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        getTableData: builder.mutation({
            query: (data) => ({ url: '/api/accounts/list', method: 'POST', body: data }),
        }),
        getContactList: builder.mutation({
            query: ({ accountId, filter }) => ({
                url: '/api/contact/list',
                method: 'POST',
                body: { AccountId: accountId, ...filter },
            }),
        }),
        getAccount: builder.query({
            query: (id) => ({ url: `/api/accounts/${id}`, method: 'GET' }),
            keepUnusedDataFor: 0,
        }),
        deleteAccount: builder.mutation({
            query: (id) => ({ url: `/api/accounts/delete/${id}`, method: 'DELETE' }),
        }),
        saveAccountDetails: builder.mutation({
            query: (model) => ({
                url: '/api/accounts/save',
                method: 'POST',
                body: {
                    ...model,
                    accountId: model.accountId || 0,
                    accountCERFilters: model.accountCERFilters || [],
                },
            }),
        }),
        undeleteAccount: builder.mutation({
            query: (id) => ({ url: `/api/accounts/undelete/${id}`, method: 'POST' }),
        }),
    }),
});

export const runAccountQuery = (dispatch, endpointName, arg) =>
    runQueryOnce(dispatch, accountApi.endpoints[endpointName], arg);

export const runAccountMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, accountApi.endpoints[endpointName], arg);

export const runAccountTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, accountApi.endpoints.getTableData, requestData);

export const runContactListTableQuery = (dispatch, accountId, filter) =>
    runTableQuery(dispatch, accountApi.endpoints.getContactList, { accountId, filter });

export default accountApi;
